// extracted by mini-css-extract-plugin
export default {"selector":"MultiSelectField_selector__q3dZw"};